import { gql } from '@apollo/client';

export const approveDeviceQuery = gql`
  mutation ApproveDevice($input: ApproveDeviceInput!) {
    approveDevice(input: $input) {
      ... on Terminal {
        id
        typename: __typename
        address
        approvalsCount
        location {
          lat
          lon
        }
        notes
        organization
        registrationDate
        status
        user {
          id
        }
      }
    }
  }
`;
